"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelAlias = void 0;
var getColors = function (colors, brand) {
    if (brand === 'massey') {
        return colors.primary.grays[600];
    }
    if (brand === 'fendt') {
        return colors.grays[800];
    }
    return colors.grays[700];
};
var getLabelAlias = function (globals, brand) {
    return {
        fontFamily: globals.fonts.secondary.regular,
        color: getColors(globals.colors, brand),
        paddingLeft: brand === 'fendt' ? 16 : 0,
    };
};
exports.getLabelAlias = getLabelAlias;
